<template>
  <div class="tab-type-presentation">
    <ul>
      <li
        @click="$emit('activeTabSlide', 1)"
        class="tab-type-presentation-item"
        :class="{ active: $store.state.slideActive.activeTab == 1 }"
        v-if="
          $store.state.slideActive.type != 'leaderboard' &&
            selectedSlideIds.length <= 1
        "
      >
        Type
      </li>
      <li
        @click="$emit('activeTabSlide', 2)"
        class="tab-type-presentation-item"
        :class="{ active: $store.state.slideActive.activeTab == 2 }"
        v-if="$store.state.slideActive.type && selectedSlideIds.length <= 1"
      >
        <span v-if="slideActive.type === 'freestyle'">Templates</span>
        <span v-else>Content</span>
      </li>
      <li
        @click="$emit('activeTabSlide', 3)"
        class="tab-type-presentation-item"
        :class="{ active: $store.state.slideActive.activeTab == 3}"
        v-if="$store.state.slideActive.type"
      >
        Design
        <i
          class="fas fa-exclamation-circle"
          :class="{ 'd-none': !contrastReminderVisible }"
          v-tooltip="
            'Not enough contrast between text colour and base colour'
          "
        ></i>
      </li>
      <li
        @click="$emit('activeTabSlide', 4)"
        class="tab-type-presentation-item"
        :class="{ active: $store.state.slideActive.activeTab == 4 }"
        v-if="showingAudioTab"
      >
        <span class="text-tab">Audio</span>
        <i class="fas fa-volume-up" v-if="slideActive.type !== 'freestyle'"></i>
        <aha-icon
          name="music-note"
          class="music-note-icon"
          v-if="slideActive.type === 'freestyle'"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import Config from '@/config'

export default {
  props: {
    selectedSlideIds: {
      type: Array,
      default: () => [],
    },
    showingAudioTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      showingSlideGrid: (state) => state.indicators.showingSlideGrid,
    }),
    contrastReminderVisible() {
      try {
        // For more info: https://dev.to/alvaromontoro/building-your-own-color-contrast-checker-4j7o
        const { slideActive } = this.$store.state
        const textColour = utils.hexToRgb(slideActive.textColour)
        const baseColour = utils.hexToRgb(slideActive.baseColour)
        if (!textColour || !baseColour) return false
        const textColourLuminance = utils.getColourLuminance(
          textColour.r,
          textColour.g,
          textColour.b,
        )
        const baseColourLuminance = utils.getColourLuminance(
          baseColour.r,
          baseColour.g,
          baseColour.b,
        )
        const contrastRatio = utils.getContrastRatio(
          textColourLuminance,
          baseColourLuminance,
        )

        // Question title font size's > 18px ( > 18pt) => AA-level passed when contrast < 1/3
        const AALevelPassedForLargeText = 1 / 3
        slideActive.contrastReminderVisible =
          contrastRatio >= AALevelPassedForLargeText
        return contrastRatio >= AALevelPassedForLargeText
      } catch {
        return false
      }
    },
    isEu() {
      return Config.region === 'eu'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';

.tab-type-presentation {
  margin: 0 -16px 0 -16px;

  ul {
    @apply border-base-30 border-b;
    padding-left: 16px;
    margin: 0;
    overflow: hidden;
    .tab-type-presentation-item {
      @apply text-sm text-secondary-100;
      list-style: none;
      float: left;
      padding: 10px 15px;
      cursor: pointer;
      position: relative;
      font-weight: bold;

      &.active {
        border-bottom: 3px solid $primary-color;
        @apply text-primary-90;
      }
      &:hover {
        color: $primary-color;
      }

      .fa-volume-up, .music-note-icon {
        display: none;
      }

      .fa-exclamation-circle {
        color: #ffb12e;
        position: absolute;
        font-size: 0.9em;
      }
    }
    @media (max-width: 360px) {
      li {
        padding: 10px 13px;
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 360px) {
  .tab-type-presentation ul .tab-type-presentation-item {
    padding: 5px 10px;
    font-size: 15px;
  }
}

@media (max-width: 798px) {
  .tab-type-presentation ul .tab-type-presentation-item {
    height: 44px;
    .fa-volume-up {
      display: block;
      position: relative;
      top: 4px;
    }
    .music-note-icon {
      display: block;
      width: 20;
      height: 20;
    }
    .text-tab {
      display: none;
    }
  }
}
</style>
